import styled, { css } from 'styled-components'
import { MEDIA } from 'src/utils'

const { MOBILE, MOBILE_UP, TABLET } = MEDIA

const activeStyle = css`
  svg {
    path {
      fill: var(--cobasi-blue-light-8);
    }
  }
  * {
    color: var(--cobasi-blue-light-8) !important;
  }

  @media screen and ${MOBILE} {
    border-bottom: 2px solid var(--cobasi-blue-light-8);
  }
`

export const TabContainer = styled.section`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100vw;
    height: fit-content;
    background-color: var(--the-white);
`

export const SideBar = styled.section`
  display: flex;
  flex-direction: column;
  min-width: 170px;
  @media screen and ${TABLET} {
    margin-left: 16px;
  }
`
export const TabItem = styled.div`
  flex: 50%;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 24px;
  padding: 16px 0;
  border-bottom: 1px solid var(--silver);
  cursor: pointer;
  &:last-of-type {
    @media screen and ${MOBILE_UP} {
      border-bottom: none;
    }
  }
  &:first-of-type {
      padding: 0 0 16px 0;
  }
  @media screen and ${MOBILE} {
    flex: 50%;
    text-align: center;
    height: 100%;
    justify-content: center;
    gap: 4px;
    padding: 8px 16px !important;
  }
  ${
    ({ active }) => active && activeStyle
  }
  ${
    ({ alignStart }) => alignStart && 'align-items: start;'
  }
`

export const TabTitle = styled.div`
  font-family: var(--primary-font);
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  color: var(--gray-2);
  @media screen and ${MOBILE} {
    font-size: 14px;
    font-weight: 400;
    color: var(--gray-5);
  }
  @media (max-width: 413px) {
    font-size: 13px;
  }
`
export const TabSubTitle = styled(TabTitle)`
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: var(--gray-5);
`
